export enum NotificationType {
  CompletedAudit = "CompletedAudit",
}
